import React, { useState, useEffect, useRef, useContext } from "react";
import { withRouter, useHistory, Redirect } from "react-router-dom";
import { PageSettings } from "../../config/page-settings";
import { useAuth0 } from "@auth0/auth0-react";
import swal from "sweetalert";
import Config from "../../Config";
import LoaderSpinner from "../../components/Loaderspinner/LoaderSpinner";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import {
    checkUserbyEmail,
    getPackageCurrencyList
} from "../../api/priceApi";
const Authcallback = (props) => {
    let history = useHistory();
    const context = useContext(PageSettings);

    const [CreateLoginloding, setCreateLoginloding] = useState(false);
    const [checkEmailloding, setcheckEmailloding] = useState(false);
    const [currencyList, setcurrencyList] = useState([]);
    const [currency, setcurrency] = useState("");
    const [currencyError, setcurrencyError] = useState("");
    const [IsmodalOpen, setIsmodalOpen] = useState(false);
    const {
        user,
        isAuthenticated,
        getAccessTokenSilently,
        error,
        isLoading,
        logout,
    } = useAuth0();
    const { loginWithRedirect } = useAuth0();
    useEffect(() => {
        context.handleSetPageSidebar(false);
        context.handleSetPageHeader(false);
        context.handleSetPageContentFullWidth(true);
        return () => {
            context.handleSetPageSidebar(true);
            context.handleSetPageHeader(true);
            context.handleSetPageContentFullWidth(false);
        };
    }, []);
    useEffect(() => {
        GetPackageCurrencyList();
    }, []);

    const GetPackageCurrencyList = async () => {
        try {
            let data = await getPackageCurrencyList();
            console.log("getPackageCurrencyListData===>", data)
            setcurrencyList(data);
            setcurrency(data[0]?.value);
        } catch (error) {
            console.log("getPackageCurrencyListE5rror==>", error)
        }
    };
    const callLogout = async () => {
        await logout()
    }
    useEffect(() => {
        const getdata = async () => {
            try {
                if (isLoading) {
                    return <LoaderSpinner isrefresh={isLoading} />;
                }
                if (isAuthenticated && !isLoading) {
                    if (user) {
                        //const token = await getAccessTokenSilently();
                        //CheckUserbyEmail(user?.email, user?.name, token, user.sub)
                        if (user?.email_verified === true) {
                            const token = await getAccessTokenSilently();
                            CheckUserbyEmail(user?.email, user?.name, token, user.sub)
                            //CreateLogin(user?.email, user?.name, token, user.sub);
                        }
                        else {
                            swal({
                                title: "Your Email Verification Is Pending.",
                                text: "Please Verify Your Email !",
                                icon: "warning",
                            }).then(async (willDelete) => {
                                await callLogout();
                            });
                        }
                    }
                    else {
                        await callLogout();
                        //history.push('/Login')
                    }
                }
            } catch (error) {
                await callLogout();
                //history.push('/Login')
            }
        }
        getdata().catch(console.error);
    }, [isAuthenticated, isLoading]);

    const CheckUserbyEmail = async (email, name, token, auth0id) => {
        let isweb = true;
        if (email !== null && email !== undefined && email !== "") {
            setcheckEmailloding(true);
            let checklogin = await checkUserbyEmail(email, isweb);
            if (checklogin === true) {
                setcheckEmailloding(false);
                await CreateLogin(email, name, token, auth0id);
            }
            else {
                setcheckEmailloding(false);
                setIsmodalOpen(true);
            }
        }

    }

    const CreateLogin = async (email, name, token, auth0id, currencyID) => {
        let isvalid = true;
        if (email === null || email === undefined || email === "") {
            isvalid = false;
        }
        if (isvalid === true) {
            let checklastpage = await localStorage.getItem("Pricingpage");
            setCreateLoginloding(true);
            var createModel = {
                email: email,
                name: name,
                Auth0ID: auth0id,
                FCMToken: "",
                currencyID: currencyID

            };

            fetch(
                Config.apiUrl +
                "UserCompany/AuthCreateUserCompany",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                    },
                    body: JSON.stringify(createModel),
                }
            )
                .then(async (result) => {
                    result.json().then(async (resp) => {
                        console.log("Praveenresponxe=>", resp);
                        setCreateLoginloding(false);
                        if (resp?.id != undefined && resp?.id != null && resp?.id != "") {
                            if (resp?.roleName === "SubUser" && resp?.isActive === false) {
                                swal({
                                    title: "Your account has been disabled.",
                                    text: "Please contact the administrator for assistance.",
                                    icon: "warning",
                                }).then(async (willDelete) => {
                                    await callLogout();
                                });
                                return;
                            }
                            localStorage.setItem("islogin", true);
                            localStorage.setItem("loginName", resp?.name);
                            localStorage.setItem("Auth0ID", auth0id);
                            localStorage.setItem("loginUserID", resp?.id);
                            localStorage.setItem("subUserIDList", resp?.subUserIDList);
                            localStorage.setItem("loginEmail", resp?.email);
                            localStorage.setItem("loginRoleName", resp?.roleName);
                            localStorage.setItem("UserCompanyId", resp?.parentID);
                            localStorage.setItem(
                                "loginUserImage",
                                Config.contentUrl + resp?.userImage
                            );
                            localStorage.setItem("Auth0token", token);

                            if (resp?.roleName === "SuperAdmin") {
                                // history.push("/supperadmin/superdashboard");
                                if (checklastpage === "true" || checklastpage === true) {
                                    // history.push("/dashboard/home");
                                    history.push("/Pricingpage");
                                } else {
                                    history.push("/superdashboard");
                                }

                            } else {
                                if (checklastpage === "true" || checklastpage === true || resp?.isPackageActive === false) {
                                    // history.push("/dashboard/home");
                                    history.push("/Pricingpage");
                                }
                                else {
                                    localStorage.removeItem('Pricingpage');
                                    history.push("/home");
                                }
                            }

                            //this.props.history.push({ pathname: '/dashboard/home' });
                        } else {
                            //history.push("/Logout");

                            await callLogout();
                            //history.push("/Login");
                        }
                    });
                })
                .catch((error) => {
                    setCreateLoginloding(false);
                    swal("error !" + error);
                    console.error("There was an error!", error);
                    //history.push("/Logout");
                });



        } else {
            await callLogout();
            history.push("/Login");
        }
    };
    const togglecurrency = async () => {
        setIsmodalOpen(false)
        await callLogout();
    }

    const saveUsercurrency = async () => {
        if (currency !== null && currency !== "" && currency !== undefined) {
            setIsmodalOpen(false)
            const token = await getAccessTokenSilently();
            await CreateLogin(user.email, user.name, token, user.sub, currency)
        }
        else {
            setcurrencyError("Please select currency");
        }
    }

    return (
        <div className="login login-with-news-feed">
            <LoaderSpinner isrefresh={CreateLoginloding || checkEmailloding} />


            <Modal isOpen={IsmodalOpen}
                // toggle={togglecurrency}
                className="static modal-lg">
                <ModalHeader toggle={togglecurrency} className="modalheader">
                    <h4 className="mb-0 text-white">Package currency</h4>{" "}
                </ModalHeader>
                <ModalBody>
                    <form className="m-b-30">
                        <div className="form-group">
                            {/* <h1>Please select trials package currency </h1> */}
                            <h1>Please select your preferred currency</h1>

                            <h2> <label htmlFor="exampleInputEmail1" className="">Select Currency</label></h2>

                            <select
                                value={currency}
                                onChange={(e) => {
                                    setcurrency(e.target.value);
                                    setcurrencyError("");
                                    console.log("e.target.value", e.target.value);
                                }}
                                class=" form-control mr-2 " style={{ height: '44px', fontSize: '16px' }}
                            >
                                <option value={""}> --- Select Currency ---</option>
                                {currencyList?.length > 0 ?
                                    currencyList?.map((item, i) => (
                                        <option value={item?.value}> {`${item?.otherName} ${item?.label}`} </option>
                                    ))
                                    : <></>}

                            </select>

                            {currencyError.length > 0 && (
                                <span style={{ color: "red", marginLeft: 6 }}>
                                    {currencyError}
                                </span>
                            )}
                        </div>
                        <div className="d-flex justify-content-center w-100">
                            <button
                                type="button"
                                onClick={() => {
                                    saveUsercurrency();
                                }}
                                className="btn btn-lg btn-primary m-r-5 me-5 shadow-add btnauth "
                            >
                                Save changes
                            </button>
                            <div style={{ marginLeft: '30px', marginTop: '20px' }}></div>
                            <button
                                type="button"
                                onClick={() => {
                                    togglecurrency()
                                }}
                                className="btn btn-lg btn-danger shadow-add btnauth "
                            >
                                Go to Login
                            </button>
                        </div>
                    </form>
                </ModalBody>
            </Modal>
        </div>)

}
export default Authcallback;